<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center position-relative pointer-events-none venns-wrap"
    :data-key="uuid"
    :style="{ height: isSmall ? vwScale(210) : '50vh' }"
  >

    <venn-fragment
      v-for="(venn, idx) in data.points"
      :key="idx"
      :percent-size="venn.fontSize"
      :active="data.primary === 'industry' ? (industry === venn.industry) : (activeIdx === idx)"
      :num-active="active"
      :label="{ title: venn.title, pos: 'bottom', align: 'middle' }"
      :target="venn.val"
      :pos="pos[idx]"
      :ind-override="indOverride"
      :style="{ [pos[idx].x]: 0, [pos[idx].y]: 0 }"
      @activated.once="activated = true"
    />

    <ring-vect v-if="!isSmall" :bg="bg" :cols="ringCols" :dash-offset="dashOffset"/>

  </div>
</template>

<script>
  import { dataTransTime } from '@/lib/consts'
  import { gradPtColor, randIntInc } from '@/lib/funcs'
  import { TweenMax, Power1 } from 'gsap'
  import GraphMixin from '@/components/report/mixins/GraphMixin'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import VennFragment from '@/components/report/content/VennFragment'
  import RingVect from '@/components/svg/RingVect'

  let y = [ 'top', 'bottom' ]
  let x = [ 'left', 'right' ]

  export default {
    name: 'Venn',
    mixins: [ ContentMixin, GraphMixin ],
    data () {
      return {
        pos1: { x: x[ randIntInc( 0, 1 ) ], y: y[ randIntInc( 0, 1 ) ] },
        activeIdx: 0,
        dashOffset: this.active ? 0 : 630
      }
    },
    computed: {
      ringCols () {
        let cols = this.bg === this.accent ? this.colors : this.colorsRev
        return [ gradPtColor( ...cols, 0.333 ), gradPtColor( ...cols, 0.9 ) ]
      },
      pos () {
        return [
          this.pos1,
          { x: this.pos1.x === 'left' ? 'right' : 'left', y: this.pos1.y === 'top' ? 'bottom' : 'top' }
        ]
      }
    },
    watch: {
      active ( val ) {
        TweenMax.to( this, dataTransTime, { dashOffset: val ? 0 : 630, ease: Power1.easeInOut } )
      }
    },
    methods: {
      toggleIdx () {
        this.activeIdx = this.activeIdx === 0 ? 1 : 0
      },
      togglePrimary () {
        switch ( this.data.primary ) {
          case 'idx':
            this.toggleIdx()
            break
          case 'industry':
            this.toggleInd()
            break
        }
      }
    },
    mounted () {
      this.$on( 'primarySwap', () => this.togglePrimary() )
      this.$on( 'botOff', () => {
        if ( this.data.primary === 'idx' ) this.toggleIdx()
      } )
    },
    components: { VennFragment, RingVect }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .venns-wrap {

    @include screen-md-lg-xl {
      width      : 60vh;
      max-width  : 600px;
      max-height : 460px;
      margin     : 0 auto;
    }
  }

  .venn-content-wrap {

    @include screen-md-lg-xl {
      margin : rem(50) 0;
    }

    .venn-wrap, .ring-vector {
      height : viewport-scale(230);

      @include screen-md-lg-xl {
        height     : 35vh;
        width      : 35vh;
        max-width  : 350px;
        max-height : 350px;
      }
    }

    .ring-vector {
      width     : viewport-scale(290);
      transform : rotate(-90deg);
    }

    .venn-wrap.active {
      z-index : 5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Venn.vue